import { SVGProps } from 'react';

export const ODPLogoMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="41"
    viewBox="0 0 25 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M-2.33985e-06 40.9999L19.0004 0.0027722L24.9991 -2.05433e-07L6.00705 40.9985L-2.33985e-06 40.9999Z"
      fill="url(#paint0_linear_odp_logomark)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_odp_logomark"
        x1="7.10443"
        y1="0.820628"
        x2="13.8645"
        y2="42.0976"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0078D6" />
        <stop offset="1" stopColor="#16E1CB" />
      </linearGradient>
    </defs>
  </svg>
);
